import { ApaduaLegacyAPI } from 'src/apis/ApaduaLegacyAPI';

export class ProposalDocumentLegacyAPI extends ApaduaLegacyAPI {
    resource: string = 'api/proposal-document-types/';

    getDocumentTypes(): Promise<any> {
        return this.get('') as any;
    }
}
